export default __webpack_public_path__ + "static/media/9.96d735f3.png";